import React, { useMemo, useState, useEffect } from 'react';
import SummaryTable from './SummaryTable';
import TeacherTooltip from '../TeacherTooltip';
import {ClassroomWithRatio, SectionRatio } from '../../types';
import './ClassroomRatios.css';
import { processedClassroomData, useClassroomData } from '../../data/classroomData';

export interface ClassroomRatiosProps {
}

const ClassroomRatios: React.FC<ClassroomRatiosProps> = () => {
  const classroomData = useClassroomData().data;
  const loading = useClassroomData().isLoading
  const { sections, specialCategories } = useMemo(()=> processedClassroomData(classroomData), [classroomData]);
  // Add state to track window width
  const [isNarrowScreen, setIsNarrowScreen] = useState<boolean>(false);
  
  // Effect to check and update screen width
  useEffect(() => {
    const checkScreenWidth = () => {
      setIsNarrowScreen(window.innerWidth < 1200); // You can adjust this breakpoint as needed
    };
    
    // Check initially
    checkScreenWidth();
    
    // Add event listener for resize
    window.addEventListener('resize', checkScreenWidth);
    
    // Clean up
    return () => window.removeEventListener('resize', checkScreenWidth);
  }, []);
  

  if (!sections || sections.length === 0) {
    return <div className="no-data">No classroom data available</div>;
  }

  // Split sections into left and right groups
  const leftSections = sections.filter(section => 
    section.name.toLowerCase().includes('infant') || 
    section.name.toLowerCase().includes('toddler')
  );

  const rightSections = sections.filter(section => 
    !section.name.toLowerCase().includes('infant') && 
    !section.name.toLowerCase().includes('toddler')
  );

  // Helper function to render the special categories table
  const renderSpecialTable = () => (
    <div className="other-table-container">
      <h3 className="summary-section-title">Other</h3>
      <table className="summary-table">
        <thead>
          <tr>
            <th>Location</th>
            <th>Teachers</th>
          </tr>
        </thead>
        <tbody>
          {specialCategories.map(classroom => (
            <tr key={classroom.id} className="special-category">
              <td>{classroom.name}</td>
              <td>
                <TeacherTooltip teachers={classroom.teachers} classroomId={classroom.id} position="right" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="classroom-ratios-component">   
      <div className="classroom-tables-container">
        {isNarrowScreen ? (
          // For narrow screens, combine all sections into a single table
          <SummaryTable sections={[...leftSections, ...rightSections]} />
        ) : (
          // For wider screens, keep the existing split view
          <>
            {leftSections.length > 0 && <SummaryTable sections={leftSections} />}
            {rightSections.length > 0 && <SummaryTable sections={rightSections} />}
          </>
        )}
      </div>
      
      {specialCategories.length > 0 && (
        <div className="special-tables-container">
          {renderSpecialTable()}
        </div>
      )}
    </div>
  );
};

export default ClassroomRatios;